module.exports = __webpack_public_path__ + "img/location-dot-sharp-thin.0b5f0534.svg";